import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/context/LanguageContext";

const LegalPage = ({ page }) => {
  const { t } = useLang();
  const data = page === "privacy" ? t.legal.privacy : t.legal.impressum;

  return (
    <div
      data-testid={`legal-page-${page}`}
      className="bg-[#121212] text-white min-h-screen"
    >
      <Navbar />

      <div className="pt-28 md:pt-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-white/60 hover:text-white transition-colors"
          >
            <ArrowLeft size={14} /> {t.projectDetail.back}
          </Link>
        </div>
      </div>

      <section className="pt-12 md:pt-20 pb-20 md:pb-32">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
            {/* Left title */}
            <div className="lg:col-span-5">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-8 bg-[#FF3B30]" />
                <p className="font-mono text-[11px] tracking-[0.3em] text-white/60">
                  {data.subtitle}
                </p>
              </div>
              <h1
                className="font-display font-extrabold text-white leading-[0.9] tracking-tight sticky top-32"
                style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
              >
                {data.title}
                <span className="text-[#FF3B30]">.</span>
              </h1>
            </div>

            {/* Right content */}
            <div className="lg:col-span-7 space-y-12">
              {data.sections.map((sec, i) => (
                <div
                  key={i}
                  className="border-t border-white/10 pt-8"
                  data-testid={`legal-section-${i}`}
                >
                  <div className="flex items-baseline gap-4 mb-5">
                    <span className="font-mono text-[10px] tracking-[0.25em] text-white/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h2 className="font-display font-extrabold text-white text-xl md:text-2xl leading-tight tracking-tight">
                      {sec.h}
                    </h2>
                  </div>
                  <div className="space-y-2 text-white/70 text-sm md:text-base leading-relaxed pl-10">
                    {sec.body.map((line, j) => (
                      <p key={j}>{line}</p>
                    ))}
                  </div>
                </div>
              ))}

              <p className="font-mono text-[10px] tracking-[0.25em] text-white/30 pt-8">
                Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalPage;
